export const DE_UI_LITERALS = {
  "Back to Home": "Zurück zur Startseite",
  "Jetzt aktualisieren": "Jetzt aktualisieren",
  "Die Unternehmensstruktur konnte nicht aktualisiert werden. Die angezeigten Einträge sind möglicherweise nicht aktuell.": "Die Unternehmensstruktur konnte nicht aktualisiert werden. Die angezeigten Einträge sind möglicherweise nicht aktuell.",
  "POS wurde angelegt. Die Unternehmensstruktur konnte nicht aktualisiert werden.": "POS wurde angelegt. Die Unternehmensstruktur konnte nicht aktualisiert werden.",
  "Ein aktives Unternehmen mit diesem Namen existiert bereits in diesem Land.": "Ein aktives Unternehmen mit diesem Namen existiert bereits in diesem Land.",
  "Eine aktive Betriebsstätte mit diesem Namen existiert bereits in diesem Unternehmen.": "Eine aktive Betriebsstätte mit diesem Namen existiert bereits in diesem Unternehmen.",
  "Letzte Archivierungen": "Letzte Archivierungen",
  "Dateien": "Dateien",
  "Archiviert": "Archiviert",
  "Keine Archivierungen verfügbar": "Keine Archivierungen verfügbar",
  "Der Archivierungsstatus konnte nicht aktualisiert werden.": "Der Archivierungsstatus konnte nicht aktualisiert werden.",
  "Der Exportstatus konnte nicht aktualisiert werden.": "Der Exportstatus konnte nicht aktualisiert werden.",
  "Archivierungen aus Web-Uploads und POS-Übermittlungen Ihrer Organisation.": "Archivierungen aus Web-Uploads und POS-Übermittlungen Ihrer Organisation.",
  "Archivierungen aus Ihren Web-Uploads.": "Archivierungen aus Ihren Web-Uploads.",
  "(+ Erste Betriebsstätte anlegen)": "(+ Erste Betriebsstätte anlegen)",
  "(+ Erste POS anlegen)": "(+ Erste POS anlegen)",
  "(+ Unternehmen in der Unternehmensstruktur hinzufügen)": "(+ Unternehmen in der Unternehmensstruktur hinzufügen)",
  "+ Betriebsstätte anlegen": "+ Betriebsstätte anlegen",
  "+ Erste Betriebsstätte anlegen": "+ Erste Betriebsstätte anlegen",
  "+ Erste POS anlegen": "+ Erste POS anlegen",
  "+ Erstes Unternehmen anlegen": "+ Erstes Unternehmen anlegen",
  "+ POS anlegen": "+ POS anlegen",
  "0 B": "0 B",
  "0.00 MB": "0.00 MB",
  "Abbrechen": "Abbrechen",
  "Leeren": "Löschen",
  "Heute": "Heute",
  "Akzeptieren": "Akzeptieren",
  "Bitte akzeptieren Sie die Geschäftsbedingungen.": "Bitte akzeptieren Sie die Geschäftsbedingungen.",
  "Bitte akzeptieren Sie die Geschäftsbedingungen, um EleFANT weiter zu verwenden.": "Bitte akzeptieren Sie die Geschäftsbedingungen, um EleFANT weiter zu verwenden.",
  "Die Zustimmung konnte nicht gespeichert werden.": "Die Zustimmung konnte nicht gespeichert werden.",
  "Das Konto wurde noch nicht aktiviert. Bitte fordern Sie einen neuen Aktivierungslink bei Ihrem Administrator an.": "Das Konto wurde noch nicht aktiviert. Bitte fordern Sie einen neuen Aktivierungslink bei Ihrem Administrator an.",
  "Für dieses Unternehmen sind keine Betriebsstätten verfügbar. Wählen Sie „Gesamtes Unternehmen“.": "Für dieses Unternehmen sind keine Betriebsstätten verfügbar. Wählen Sie „Gesamtes Unternehmen“.",
  "Für dieses Unternehmen sind keine POS verfügbar. Wählen Sie „Gesamtes Unternehmen“.": "Für dieses Unternehmen sind keine POS verfügbar. Wählen Sie „Gesamtes Unternehmen“.",
  "Für dieses Unternehmen sind keine POS verfügbar. Wählen Sie „Ausgewählte Betriebsstätten“ oder „Gesamtes Unternehmen“.": "Für dieses Unternehmen sind keine POS verfügbar. Wählen Sie „Ausgewählte Betriebsstätten“ oder „Gesamtes Unternehmen“.",
  "Zustimmung wird gespeichert…": "Zustimmung wird gespeichert…",
  "Aktion bestätigen": "Aktion bestätigen",
  "Administration": "Administration",
  "Akteur": "Akteur",
  "Aktion": "Aktion",
  "Aktion erforderlich: Unternehmen wählen.": "Aktion erforderlich: Unternehmen wählen.",
  "Aktion erforderlich: mindestens eine Betriebsstätte wählen.": "Aktion erforderlich: mindestens eine Betriebsstätte wählen.",
  "Aktion erforderlich: POS wählen.": "Aktion erforderlich: POS wählen.",
  "Aktion erforderlich: Zeitraum vollständig wählen (Von/Bis).": "Aktion erforderlich: Zeitraum vollständig wählen (Von/Bis).",
  "Aktion fehlgeschlagen.": "Aktion fehlgeschlagen.",
  "Aktionen": "Aktionen",
  "Auswahl": "Auswahl",
  "Benachrichtigung schließen": "Benachrichtigung schließen",
  "Ausstehend": "Ausstehend",
  "Aktiv": "Aktiv",
  "Aktivieren": "Aktivieren",
  "Aktivierte Elemente": "Aktivierte Elemente",
  "Aktualisieren": "Aktualisieren",
  "Aktueller Export": "Aktueller Export",
  "Alle hochgeladenen Dateien und Auswahlen werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden.": "Alle hochgeladenen Dateien und Auswahlen werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  "Andere": "Andere",
  "Anfrage erstellen": "Anfrage erstellen",
  "Anfrage offen": "Anfrage offen",
  "Anfrage ausstehend": "Anfrage ausstehend",
  "Anfrage ausblenden": "Anfrage ausblenden",
  "Anfrage stellen": "Anfrage stellen",
  "Anfrager": "Anfrager",
  "Anlegen": "Anlegen",
  "Anlegen ausblenden": "Anlegen ausblenden",
  "Organisationsanlage ausblenden": "Organisationsanlage ausblenden",
  "Reseller-Anlage ausblenden": "Reseller-Anlage ausblenden",
  "Einladung erneut senden": "Einladung erneut senden",
  "Einladung konnte nicht erneut gesendet werden.": "Einladung konnte nicht erneut gesendet werden.",
  "Einladung wurde erneut gesendet.": "Einladung wurde erneut gesendet.",
  "Reseller konnte nicht angelegt werden.": "Reseller konnte nicht angelegt werden.",
  "Anmeldung…": "Anmeldung…",
  "Ansprechpartner": "Ansprechpartner",
  "Anzahl Elemente": "Anzahl Elemente",
  "API-Key Aktualisierung": "API-Key Aktualisierung",
  "API-Key Freigabe": "API-Key Freigabe",
  "API-Key Verwaltung": "API-Key Verwaltung",
  "API-Key für": "API-Key für",
  "API-Key konnte nicht kopiert werden.": "API-Key konnte nicht kopiert werden.",
  "API-Key kopieren": "API-Key kopieren",
  "API-Key kopiert": "API-Key kopiert",
  "Onboarding-Code konnte nicht kopiert werden.": "Onboarding-Code konnte nicht kopiert werden.",
  "Onboarding-Code konnte nicht erzeugt werden.": "Onboarding-Code konnte nicht erzeugt werden.",
  "Mandant wurde gelöscht.": "Mandant wurde gelöscht.",
  "Keine Berechtigung, einen Onboarding-Code zu erzeugen.": "Keine Berechtigung, einen Onboarding-Code zu erzeugen.",
  "Bitte erneut anmelden.": "Bitte erneut anmelden.",
  "Ein Onboarding-Code erlaubt es einer oder mehreren Kassen, sich automatisch zu registrieren und jeweils einen eigenen API-Key anzufordern. Ein API-Key ist genau einer Kasse zugeordnet. Er ist das Geheimnis, mit dem sich die Kasse gegenüber dem Service identifiziert, und darf nicht zwischen mehreren Kassen geteilt werden. Der Onboarding-Code darf dagegen von mehreren Kassen verwendet werden. Jeder angeforderte API-Key muss anschließend in der API-Key-Verwaltung freigegeben werden.": "Ein Onboarding-Code erlaubt es einer oder mehreren Kassen, sich automatisch zu registrieren und jeweils einen eigenen API-Key anzufordern. Ein API-Key ist genau einer Kasse zugeordnet. Er ist das Geheimnis, mit dem sich die Kasse gegenüber dem Service identifiziert, und darf nicht zwischen mehreren Kassen geteilt werden. Der Onboarding-Code darf dagegen von mehreren Kassen verwendet werden. Jeder angeforderte API-Key muss anschließend in der API-Key-Verwaltung freigegeben werden.",
  "Onboarding-Codes sind zeitlich unbegrenzt gültig und werden im Portal nur einmal angezeigt. Wenn Sie einen Code verlieren, erzeugen Sie einen neuen; bereits erzeugte Codes bleiben weiterhin gültig.": "Onboarding-Codes sind zeitlich unbegrenzt gültig und werden im Portal nur einmal angezeigt. Wenn Sie einen Code verlieren, erzeugen Sie einen neuen; bereits erzeugte Codes bleiben weiterhin gültig.",
  "Onboarding-Code erzeugen": "Onboarding-Code erzeugen",
  "Weiteren Onboarding-Code erzeugen": "Weiteren Onboarding-Code erzeugen",
  "Abgelaufen": "Abgelaufen",
  "Fehlgeschlagen": "Fehlgeschlagen",
  "In Bearbeitung": "In Bearbeitung",
  "Erzeugt…": "Erzeugt…",
  "Onboarding-Code": "Onboarding-Code",
  "Onboarding-Code kopieren": "Onboarding-Code kopieren",
  "Onboarding-Code kopiert": "Onboarding-Code kopiert",
  "Kopieren": "Kopieren",
  "Kopiert": "Kopiert",
  "Gültig bis": "Gültig bis",
  "Verfügbar bis": "Verfügbar bis",
  "API-Key Verwaltung ist im Tenant-Admin Kontext verfügbar.": "API-Key Verwaltung ist im Hauptnutzer-Kontext verfügbar.",
  "API-Keys": "API-Keys",
  "API-Keys verwalten": "API-Keys verwalten",
  "Kassen/POS und API-Keys verwalten": "Kassen/POS und API-Keys verwalten",
  "API-Key einrichten": "API-Key einrichten",
  "API-Key löschen": "API-Key löschen",
  "Die POS wurde erfolgreich erstellt. Für den sicheren Upload und die Archivierung von Artefakten benötigt sie einen API-Key.": "Die POS wurde erfolgreich erstellt. Für den sicheren Upload und die Archivierung von Artefakten benötigt sie einen API-Key.",
  "Der API-Key wird nur einmal angezeigt. Kopieren Sie ihn jetzt und bewahren Sie ihn sicher auf. Geben Sie ihn nicht an Dritte weiter und entfernen Sie ihn nach der Einrichtung aus allen temporären Ablagen.": "Der API-Key wird nur einmal angezeigt. Kopieren Sie ihn jetzt und bewahren Sie ihn sicher auf. Geben Sie ihn nicht an Dritte weiter und entfernen Sie ihn nach der Einrichtung aus allen temporären Ablagen.",
  "Archiv": "Archiv",
  "Archivdaten konnten nicht geladen werden.": "Archivdaten konnten nicht geladen werden.",
  "Archivierte Elemente werden in diesem Zeitraum beim Export exportiert.": "Archivierte Elemente werden in diesem Zeitraum beim Export exportiert.",
  "Artefakte": "Artefakte",
  "Artefaktgruppe": "Artefaktgruppe",
  "Aufklappen": "Aufklappen",
  "Alle aufklappen": "Alle aufklappen",
  "Alle zuklappen": "Alle zuklappen",
  "Bearbeiten": "Bearbeiten",
  "Betriebsstätte": "Betriebsstätte",
  "Betriebsstätten": "Betriebsstätten",
  "Betriebsstätte (optional)": "Betriebsstätte (optional)",
  "Betriebsstätten (optional)": "Betriebsstätten (optional)",
  "Betriebsstätte neu anlegen": "Betriebsstätte neu anlegen",
  "Betriebsstätten verwalten": "Betriebsstätten verwalten",
  "Bis": "Bis",
  "Bitte alle Passwortfelder ausfüllen.": "Bitte alle Passwortfelder ausfüllen.",
  "Bitte E-Mail und Passwort eingeben.": "Bitte E-Mail und Passwort eingeben.",
  "Bitte E-Mail eingeben.": "Bitte E-Mail eingeben.",
  "Bitte E-Mail-Adresse des Empfängers eingeben.": "Bitte E-Mail-Adresse des Empfängers eingeben.",
  "Bitte Passwort eingeben.": "Bitte Passwort eingeben.",
  "Bitte neues Passwort eingeben.": "Bitte neues Passwort eingeben.",
  "Bitte Passwort wiederholen.": "Bitte Passwort wiederholen.",
  "Bitte Unternehmensname eingeben.": "Bitte Unternehmensname eingeben.",
  "Bitte Betriebsstätte eingeben.": "Bitte Betriebsstätte eingeben.",
  "Bitte ein Land auswählen.": "Bitte ein Land auswählen.",
  "Bitte alle Pflichtfelder ausfüllen.": "Bitte alle Pflichtfelder ausfüllen.",
  "Bitte ein Unternehmen wählen.": "Bitte ein Unternehmen wählen.",
  "Bitte eine Datei auswählen.": "Bitte eine Datei auswählen.",
  "Bitte einen Namen für den Passkey angeben.": "Bitte einen Namen für den Passkey angeben.",
  "Bestätigen": "Bestätigen",
  "Betriebsstätte löschen": "Betriebsstätte löschen",
  "Bitte mindestens ein Unternehmen wählen.": "Bitte mindestens ein Unternehmen wählen.",
  "Bitte eine Bezeichnung für die benutzerdefinierte Artefaktgruppe angeben.": "Bitte eine Bezeichnung für die benutzerdefinierte Artefaktgruppe angeben.",
  "Bitte mindestens eine Kategorie auswählen.": "Bitte mindestens eine Kategorie auswählen.",
  "Bitte neuen Betriebsstättennamen angeben.": "Bitte neuen Betriebsstättennamen angeben.",
  "Bitte neuen Unternehmensnamen und Land angeben.": "Bitte neuen Unternehmensnamen und Land angeben.",
  "Bitte ein Land mit aktivem Profil wählen.": "Bitte ein Land mit aktivem Profil wählen.",
  "Bitte ein Unternehmen aus einem Land mit aktivem Profil wählen.": "Bitte ein Unternehmen aus einem Land mit aktivem Profil wählen.",
  "Bitte POS-Seriennummer angeben.": "Bitte POS-Seriennummer angeben.",
  "Bitte Unternehmen/Betriebsstätte wählen oder neu anlegen.": "Bitte Unternehmen/Betriebsstätte wählen oder neu anlegen.",
  "Bitte wählen": "Bitte wählen",
  "Bitte Zeitraum vollständig wählen (Von/Bis).": "Bitte Zeitraum vollständig wählen (Von/Bis).",
  "Bitte zuerst Filter anwenden und Treffer erzeugen.": "Bitte zuerst Filter anwenden und Treffer erzeugen.",
  "Bitte zuerst speichern, damit die neuen Werte aktiv werden.": "Bitte zuerst speichern, damit die neuen Werte aktiv werden.",
  "Changelog": "Changelog",
  "Cloud-Upload": "Cloud-Upload",
  "Commit fehlgeschlagen.": "Commit fehlgeschlagen.",
  "Upload abgelehnt: Das Speicherlimit von 25 GB für diese Betriebsstätte ist erreicht.": "Upload abgelehnt: Das Speicherlimit von 25 GB für diese Betriebsstätte ist erreicht.",
  "Upload abgelehnt: Das Speicherlimit von 1 GB für unternehmensweite Artefakte dieser Organisation ist erreicht.": "Upload abgelehnt: Das Speicherlimit von 1 GB für unternehmensweite Artefakte dieser Organisation ist erreicht.",
  "Upload abgelehnt: Die ausgewählte Dateigruppe überschreitet die maximale Gesamtgröße.": "Upload abgelehnt: Die ausgewählte Dateigruppe überschreitet die maximale Gesamtgröße.",
  "Datei": "Datei",
  "Datei hinzufügen": "Datei hinzufügen",
  "Datei löschen": "Datei löschen",
  "Datei konnte nicht entfernt werden.": "Datei konnte nicht entfernt werden.",
  "Dateiliste": "Dateiliste",
  "Daten archivieren": "Daten archivieren",
  "Datenschutz": "Datenschutz",
  "Datum": "Datum",
  "DE": "DE",
  "de-DE": "de-DE",
  "Deaktivieren": "Deaktivieren",
  "Deaktiviert": "Deaktiviert",
  "Schließen": "Schließen",
  "deleteExport failed:": "deleteExport failed:",
  "deleteExport returned 400": "deleteExport returned 400",
  "deleteExport returned 404": "deleteExport returned 404",
  "Demo Organisation": "Demo Organisation",
  "Der Export löscht die Daten und macht den TSE Speicher wieder frei.": "Der Export löscht die Daten und macht den TSE Speicher wieder frei.",
  "Sobald er bereitsteht, kann der Export 7 Tage lang heruntergeladen werden.": "Sobald er bereitsteht, kann der Export 7 Tage lang heruntergeladen werden.",
  "Export herunterladen": "Export herunterladen",
  "Der offene Web-Upload enthält Dateien, die noch nicht archiviert sind. Beim Verlassen der aktuellen Sitzung werden diese Dateien und alle Upload-Auswahlen verworfen. Dies kann nicht rückgängig gemacht werden.": "Der offene Web-Upload enthält Dateien, die noch nicht archiviert sind. Beim Verlassen der aktuellen Sitzung werden diese Dateien und alle Upload-Auswahlen verworfen. Dies kann nicht rückgängig gemacht werden.",
  "Di": "Di",
  "Dialog geöffnet": "Dialog geöffnet",
  "Dialog schließen": "Dialog schließen",
  "Die Daten sind auf dem Weg ins Archiv. Sie können den Dialog schliessen.": "Die Daten sind auf dem Weg ins Archiv. Sie können den Dialog schliessen.",
  "Diese Details sind für diesen Upload eingefroren. Verwerfen Sie den Upload, um sie wieder zu ändern.": "Diese Details sind für diesen Upload eingefroren. Verwerfen Sie den Upload, um sie wieder zu ändern.",
  "Direkt": "Direkt",
  "DN TSE Cloud": "DN TSE Cloud",
  "Do": "Do",
  "downloadUrl missing": "downloadUrl missing",
  "E-Mail": "E-Mail",
  "E-Mail Tenant-Admin": "E-Mail Hauptnutzer",
  "Export per E-Mail senden (optional, Prüfer/Revision)": "Export per E-Mail senden (optional, Prüfer/Revision)",
  "Editieren": "Editieren",
  "Ein Jahr vor": "Ein Jahr vor",
  "Ein Jahr zurück": "Ein Jahr zurück",
  "Ein Monat vor": "Ein Monat vor",
  "Ein Monat zurück": "Ein Monat zurück",
  "Einloggen": "Einloggen",
  "Electronic Ledger For Auditability, iNtegrity and Traceability": "Electronic Ledger For Auditability, iNtegrity and Traceability",
  "Electronic Ledger for Auditability, Integrity and Traceability": "Electronic Ledger for Auditability, Integrity and Traceability",
  "ELeFANT": "ELeFANT",
  "ELeFANT Sound abspielen": "ELeFANT Sound abspielen",
  "Entfernen": "Entfernen",
  "Entsperren": "Entsperren",
  "Zurückziehen": "Zurückziehen",
  "Erstellt am": "Erstellt am",
  "Event": "Event",
  "Export durchführen": "Export durchführen",
  "Export fehlgeschlagen.": "Export fehlgeschlagen.",
  "Export ID": "Export ID",
  "exportStatus failed:": "exportStatus failed:",
  "Fertig": "Fertig",
  "Filter": "Filter",
  "Filter anwenden": "Filter anwenden",
  "Filter...": "Filter...",
  "fiskaly Cloud TSE": "fiskaly Cloud TSE",
  "fiskaly Cloud TSE ist aktuell nicht unterstützt.": "fiskaly Cloud TSE ist aktuell nicht unterstützt.",
  "Fr": "Fr",
  "Benutzerdefiniert": "Benutzerdefiniert",
  "Belegdaten / Kassendaten": "Belegdaten / Kassendaten",
  "Bezeichnung des benutzerdefinierten Typs": "Bezeichnung des benutzerdefinierten Typs",
  "„Benutzerdefiniert“ ist nur für Ausnahmefälle vorgesehen, in denen das Artefakt keiner vorhandenen Gruppe zugeordnet werden kann. Wenden Sie sich bei wiederkehrendem Bedarf an Ihren zuständigen Supportkontakt.": "„Benutzerdefiniert“ ist nur für Ausnahmefälle vorgesehen, in denen das Artefakt keiner vorhandenen Gruppe zugeordnet werden kann. Wenden Sie sich bei wiederkehrendem Bedarf an Ihren zuständigen Supportkontakt.",
  "Freigeben": "Freigeben",
  "Freigegeben": "Freigegeben",
  "Für das Unternehmensland gibt es kein aktives Profil.": "Für das Unternehmensland gibt es kein aktives Profil.",
  "GB": "GB",
  "Gelöschte Einträge zum Filtern anbieten": "Gelöschte Einträge zum Filtern anbieten",
  "Gelöschte Elemente konnten nicht geladen werden.": "Gelöschte Elemente konnten nicht geladen werden.",
  "Gemeldete Eigenschaften": "Gemeldete Eigenschaften",
  "Genehmigen": "Genehmigen",
  "Helfer": "Helfer",
  "Geschäftsbedingungen": "Geschäftsbedingungen",
  "Geschäftsbedingungen akzeptieren": "Geschäftsbedingungen akzeptieren",
  "Gesperrt": "Gesperrt",
  "Helfer per E-Mail hinzufügen": "Helfer per E-Mail hinzufügen",
  "Hier einloggen": "Hier einloggen",
  "Ich akzeptiere die": "Ich akzeptiere die",
  "Impersonation": "Vollzugriff",
  "Impersonation anfragen": "Vollzugriff anfragen",
  "Impersonation-Anfrage zurückziehen": "Vollzugriffs-Anfrage zurückziehen",
  "Impersonation-Freigabe zurückziehen": "Vollzugriffs-Freigabe zurückziehen",
  "Impersonation beenden": "Vollzugriff beenden",
  "Impersonation-Anfragen": "Vollzugriffs-Anfragen",
  "für den EleFANT-Dienst.": "für den EleFANT-Dienst.",
  "Impersonieren": "Vollzugriff",
  "Impersonieren (inaktiv)": "Vollzugriff (inaktiv)",
  "Impersonisation": "Vollzugriff verwalten",
  "Impersonisation verwalten": "Vollzugriff verwalten",
  "Impressum": "Impressum",
  "In diesem Dialog können Sie Kriterien auswählen, was im Export enthalten sein soll.": "In diesem Dialog können Sie Kriterien auswählen, was im Export enthalten sein soll.",
  "Initialpasswort": "Initialpasswort",
  "Initialpasswort muss mindestens 8 Zeichen haben.": "Initialpasswort muss mindestens 8 Zeichen haben.",
  "invalid exportStatus response": "invalid exportStatus response",
  "invalid file_meta JSON": "invalid file_meta JSON",
  "invalid listExports response": "invalid listExports response",
  "invalid startExport response": "invalid startExport response",
  "invalid TAR export": "invalid TAR export",
  "iShield Key 2 Pro": "iShield Key 2 Pro",
  "Kassen/POS verwalten": "Kassen/POS verwalten",
  "Kategorien": "Kategorien",
  "Kein aktives Länderprofil": "Kein aktives Länderprofil",
  "Kein gemeinsames wirksames Profil für die gewählte Unternehmensauswahl verfügbar.": "Kein gemeinsames wirksames Profil für die gewählte Unternehmensauswahl verfügbar.",
  "Kein Land mit aktivem Profil": "Kein Land mit aktivem Profil",
  "Kein offener Upload.": "Kein offener Upload.",
  "Kein offener Upload. Erst Datei hinzufügen.": "Kein offener Upload. Erst Datei hinzufügen.",
  "Keine Anfragen": "Keine Anfragen",
  "Keine API-Keys definiert": "Keine API-Keys definiert",
  "Keine Betriebsstätten": "Keine Betriebsstätten",
  "Keine Betriebsstätten verfügbar": "Keine Betriebsstätten verfügbar",
  "Keine Dateien im offenen Upload.": "Keine Dateien im offenen Upload.",
  "Keine Daten": "Keine Daten",
  "Keine Einträge vorhanden": "Keine Einträge vorhanden",
  "Keine Unternehmen verfügbar": "Keine Unternehmen verfügbar",
  "Keine Helfer vorhanden": "Keine Helfer vorhanden",
  "Keine Kategorien verfügbar": "Keine Kategorien verfügbar",
  "Keine Exporte verfügbar": "Keine Exporte verfügbar",
  "Keine Impersonation-Anfragen vorhanden": "Keine Impersonation-Anfragen vorhanden",
  "Keine Passkeys vorhanden": "Keine Passkeys vorhanden",
  "Keine Nutzer vorhanden": "Keine Nutzer vorhanden",
  "Keine Organisationen oder Reseller vorhanden": "Keine Organisationen oder Reseller vorhanden",
  "Keine passende Organisation gefunden": "Keine passende Organisation gefunden",
  "Keine passenden Anfragen gefunden": "Keine passenden Anfragen gefunden",
  "Keine passenden API-Keys gefunden": "Keine passenden API-Keys gefunden",
  "Keine passenden Einträge gefunden": "Keine passenden Einträge gefunden",
  "Keine passenden Helfer gefunden": "Keine passenden Helfer gefunden",
  "Keine passenden Nutzer gefunden": "Keine passenden Nutzer gefunden",
  "Keine passenden POS gefunden": "Keine passenden POS gefunden",
  "Keine POS": "Keine POS",
  "Keine POS verfügbar": "Keine POS verfügbar",
  "Keine Treffer für die gewählten Filter": "Keine Treffer für die gewählten Filter",
  "Keine Unternehmen vorhanden": "Keine Unternehmen vorhanden",
  "Klartext Name": "Klartext Name",
  "Kundenorganisation anlegen": "Kundenorganisation anlegen",
  "Land": "Land",
  "Land (ISO-2)": "Land (ISO-2)",
  "Letzte Exporte": "Letzte Exporte",
  "Weitere Filterung nach Betriebsstätte oder POS ist bei Auswahl mehrerer Unternehmen nicht möglich.": "Weitere Filterung nach Betriebsstätte oder POS ist bei Auswahl mehrerer Unternehmen nicht möglich.",
  "listExports failed:": "listExports failed:",
  "Login fehlgeschlagen.": "Login fehlgeschlagen.",
  "LogMessages.csv column logTime missing": "LogMessages.csv column logTime missing",
  "LogMessages.csv header missing": "LogMessages.csv header missing",
  "LogMessages.csv inconsistent: no valid logTime rows": "LogMessages.csv inconsistent: no valid logTime rows",
  "LogMessages.csv is not valid UTF-8": "LogMessages.csv is not valid UTF-8",
  "LogMessages.csv unreadable in TAR export": "LogMessages.csv unreadable in TAR export",
  "Link abgelaufen": "Link abgelaufen",
  "Logout": "Logout",
  "Offenen Upload verwerfen und ausloggen?": "Offenen Upload verwerfen und ausloggen?",
  "Offenen Upload verwerfen und Impersonation beenden?": "Offenen Upload verwerfen und Vollzugriff beenden?",
  "Lädt…": "Lädt…",
  "Länderkürzel": "Länderkürzel",
  "Wird angefordert…": "Wird angefordert…",
  "Löschen": "Löschen",
  "MB": "MB",
  "Mehrere Dateien können in einen offenen Upload gebündelt werden.": "Mehrere Dateien können in einen offenen Upload gebündelt werden.",
  "Mi": "Mi",
  "Mindestens 8 Zeichen": "Mindestens 8 Zeichen",
  "Mit Passkey anmelden": "Mit Passkey anmelden",
  "Mo": "Mo",
  "Name": "Name",
  "Name Reseller-Admin (optional)": "Name Reseller-Admin (optional)",
  "Name Tenant-Admin": "Name Hauptnutzer",
  "Navigation schließen": "Navigation schließen",
  "Nutzerverwaltung öffnen": "Nutzerverwaltung öffnen",
  "Nutzerverwaltung ausblenden": "Nutzerverwaltung ausblenden",
  "Vollzugriff": "Vollzugriff",
  "Vollzugriff öffnen": "Vollzugriff öffnen",
  "Vollzugriff ausblenden": "Vollzugriff ausblenden",
  "Organisation bearbeiten": "Organisation bearbeiten",
  "Organisation ausblenden": "Organisation ausblenden",
  "Navigation öffnen": "Navigation öffnen",
  "Neu": "Neu",
  "Neue Organisation anlegen": "Neue Organisation anlegen",
  "Neues Passwort": "Neues Passwort",
  "Neues Passwort muss mindestens 8 Zeichen haben.": "Neues Passwort muss mindestens 8 Zeichen haben.",
  "Neues Passwort und Wiederholung stimmen nicht überein.": "Neues Passwort und Wiederholung stimmen nicht überein.",
  "new password too short (min 8)": "new password too short (min 8)",
  "Nicht freigegeben": "Nicht freigegeben",
  "Nicht gefunden": "Nicht gefunden",
  "Nur Cloud TSE wird unterstützt.": "Nur Cloud TSE wird unterstützt.",
  "Nur Leserechte: API-Keys können nicht bearbeitet werden.": "Nur Leserechte: API-Keys können nicht bearbeitet werden.",
  "Nutzer": "Nutzer",
  "Nutzer aktualisiert.": "Nutzer aktualisiert.",
  "Nutzer angelegt.": "Nutzer angelegt.",
  "Nutzeranlage ausblenden": "Nutzeranlage ausblenden",
  "Nutzer anlegen": "Nutzer anlegen",
  "Nutzer editieren": "Nutzer editieren",
  "Nutzer entsperren": "Nutzer entsperren",
  "Nutzer gelöscht.": "Nutzer gelöscht.",
  "Nutzer löschen": "Nutzer löschen",
  "Nutzer sperren": "Nutzer sperren",
  "Nutzer wurde entsperrt.": "Nutzer wurde entsperrt.",
  "Nutzer wurde gesperrt.": "Nutzer wurde gesperrt.",
  "Nutzerrechte": "Nutzerrechte",
  "Nutzerrechte bearbeiten": "Nutzerrechte bearbeiten",
  "Nutzerverwaltung": "Nutzerverwaltung",
  "Neuen Code erzeugen": "Neuen Code erzeugen",
  "Ausgewählte Betriebsstätten": "Ausgewählte Betriebsstätten",
  "Ausgewählte POS": "Ausgewählte POS",
  "Ausgewählt": "Ausgewählt",
  "Bitte mindestens eine Betriebsstätte wählen.": "Bitte mindestens eine Betriebsstätte wählen.",
  "Bitte eine POS wählen.": "Bitte eine POS wählen.",
  "Der vollständige Unternehmensbaum mit allen Betriebsstätten und POS wird exportiert.": "Der vollständige Unternehmensbaum mit allen Betriebsstätten und POS wird exportiert.",
  "Gesamtes Unternehmen": "Gesamtes Unternehmen",
  "Kein wirksames Profil für das gewählte Unternehmen verfügbar.": "Kein wirksames Profil für das gewählte Unternehmen verfügbar.",
  "Ohne Betriebsstätten-Auswahl stehen alle POS des Unternehmens zur Auswahl.": "Ohne Betriebsstätten-Auswahl stehen alle POS des Unternehmens zur Auswahl.",
  "Ohne POS-Auswahl gilt der Upload für das gesamte Unternehmen oder, falls eine Betriebsstätte ausgewählt ist, für diese Betriebsstätte. Es kann maximal eine POS ausgewählt werden.": "Ohne POS-Auswahl gilt der Upload für das gesamte Unternehmen oder, falls eine Betriebsstätte ausgewählt ist, für diese Betriebsstätte. Es kann maximal eine POS ausgewählt werden.",
  "Bei Auswahl von Betriebsstätten werden nur deren POS angeboten. Ohne Auswahl werden alle POS des Unternehmens angeboten.": "Bei Auswahl von Betriebsstätten werden nur deren POS angeboten. Ohne Auswahl werden alle POS des Unternehmens angeboten.",
  "Bei POS-Auswahl werden betriebsstättenweite Artefakte der zugehörigen Betriebsstätten sowie unternehmensweite Artefakte berücksichtigt.": "Bei POS-Auswahl werden betriebsstättenweite Artefakte der zugehörigen Betriebsstätten sowie unternehmensweite Artefakte berücksichtigt.",
  "Unternehmensweite Artefakte werden unabhängig von Betriebsstätten- oder POS-Auswahl immer berücksichtigt.": "Unternehmensweite Artefakte werden unabhängig von Betriebsstätten- oder POS-Auswahl immer berücksichtigt.",
  "Der Export umfasst unternehmensweite Artefakte sowie alle Artefakte der ausgewählten Betriebsstätten und ihrer POS.": "Der Export umfasst unternehmensweite Artefakte sowie alle Artefakte der ausgewählten Betriebsstätten und ihrer POS.",
  "Der Export umfasst unternehmensweite Artefakte, betriebsstättenweite Artefakte der zugehörigen Betriebsstätte und Artefakte der ausgewählten POS.": "Der Export umfasst unternehmensweite Artefakte, betriebsstättenweite Artefakte der zugehörigen Betriebsstätte und Artefakte der ausgewählten POS.",
  "Umfang": "Umfang",
  "OK": "OK",
  "Organisation": "Organisation",
  "Organisation aktivieren oder deaktivieren": "Organisation aktivieren oder deaktivieren",
  "Organisation editieren": "Organisation editieren",
  "Organisation impersonieren": "Vollzugriff auf Organisation",
  "Organisation/Kontakt konnten nicht vollständig aktualisiert werden (Backend-Endpoint fehlt). Backend neu starten.": "Organisation/Kontakt konnten nicht vollständig aktualisiert werden (Backend-Endpoint fehlt). Backend neu starten.",
  "Organisationsname": "Organisationsname",
  "Organisationsverwaltung": "Organisationsverwaltung",
  "Passkey": "Passkey",
  "Passkey aktualisiert.": "Passkey aktualisiert.",
  "Passkey editieren": "Passkey editieren",
  "Passkey gelöscht.": "Passkey gelöscht.",
  "Passkey hinzufügen": "Passkey hinzufügen",
  "Passkey hinzugefügt.": "Passkey hinzugefügt.",
  "Passkey konnte nicht erstellt werden.": "Passkey konnte nicht erstellt werden.",
  "Passwort vergessen?": "Passwort vergessen?",
  "Konto aktivieren": "Konto aktivieren",
  "Passwort setzen": "Passwort setzen",
  "Konto wird aktiviert…": "Konto wird aktiviert…",
  "Prüfe Aktivierungslink…": "Prüfe Aktivierungslink…",
  "Aktivierungslink fehlt oder ist ungültig.": "Aktivierungslink fehlt oder ist ungültig.",
  "Aktivierungslink ist ungültig oder abgelaufen.": "Aktivierungslink ist ungültig oder abgelaufen.",
  "Aktivierungslink ist ungültig oder abgelaufen. Bitte fordern Sie eine neue Einladung bei Ihrem Administrator an.": "Aktivierungslink ist ungültig oder abgelaufen. Bitte fordern Sie eine neue Einladung bei Ihrem Administrator an.",
  "Aktivierungslink konnte nicht geprüft werden.": "Aktivierungslink konnte nicht geprüft werden.",
  "Konto aktiviert. Sie können sich jetzt einloggen.": "Konto aktiviert. Sie können sich jetzt einloggen.",
  "Passwort zurückgesetzt. Sie können sich jetzt einloggen.": "Passwort zurückgesetzt. Sie können sich jetzt einloggen.",
  "Passwort zurücksetzen fehlgeschlagen.": "Passwort zurücksetzen fehlgeschlagen.",
  "Passwort vergessen fehlgeschlagen.": "Passwort vergessen fehlgeschlagen.",
  "Passkey löschen": "Passkey löschen",
  "Passkey nicht unterstützt": "Passkey nicht unterstützt",
  "Passkey registrieren": "Passkey registrieren",
  "Passkey-Anlage ausblenden": "Passkey-Anlage ausblenden",
  "Passkey-Anmeldung abgebrochen.": "Passkey-Anmeldung abgebrochen.",
  "Passkey-Anmeldung fehlgeschlagen.": "Passkey-Anmeldung fehlgeschlagen.",
  "Passkey-Backend nicht verfügbar (WebAuthn-Modul fehlt oder Server nicht neu gestartet).": "Passkey-Backend nicht verfügbar (WebAuthn-Modul fehlt oder Server nicht neu gestartet).",
  "Passkeys ausblenden": "Passkeys ausblenden",
  "Passkey-Registrierung abgebrochen.": "Passkey-Registrierung abgebrochen.",
  "Passkeys verwalten": "Passkeys verwalten",
  "Passkeys werden von diesem Browser nicht unterstützt.": "Passkeys werden von diesem Browser nicht unterstützt.",
  "password too short (min 8)": "password too short (min 8)",
  "Passwort": "Passwort",
  "Passwort anzeigen": "Passwort anzeigen",
  "Passwort verbergen": "Passwort verbergen",
  "Passwort speichern": "Passwort speichern",
  "Passwort wiederholen": "Passwort wiederholen",
  "Passwort wurde geändert.": "Passwort wurde geändert.",
  "Passwort ändern": "Passwort ändern",
  "Passwortänderung ausblenden": "Passwortänderung ausblenden",
  "PATCH": "PATCH",
  "Pending": "Pending",
  "Platform Admin": "Platform Admin",
  "POS (optional)": "POS (optional)",
  "POS Bezeichnung": "POS Bezeichnung",
  "POS Bezeichnung (optional)": "POS Bezeichnung (optional)",
  "POS ID": "POS ID",
  "POS ist bei Auswahl mehrerer Unternehmen deaktiviert.": "POS ist bei Auswahl mehrerer Unternehmen deaktiviert.",
  "POS konnte nicht angelegt werden.": "POS konnte nicht angelegt werden.",
  "POS nicht gefunden.": "POS nicht gefunden.",
  "POS Scope": "POS Scope",
  "POS-Einstellungen konnten nicht gespeichert werden.": "POS-Einstellungen konnten nicht gespeichert werden.",
  "POS-ID": "POS-ID",
  "Die POS-Seriennummer wird aus den gemeldeten Eigenschaften übernommen und nicht manuell bearbeitet.": "Die POS-Seriennummer wird aus den gemeldeten Eigenschaften übernommen und nicht manuell bearbeitet.",
  "POS Seriennummer": "POS Seriennummer",
  "POS-Upload": "POS-Upload",
  "POST": "POST",
  "Preview": "Preview",
  "Preview wird nach Klick auf „Filter anwenden“ angezeigt.": "Preview wird nach Klick auf „Filter anwenden“ angezeigt.",
  "pruefer@beispiel.de": "pruefer@beispiel.de",
  "Prüfexport": "Prüfer Export",
  "PUT": "PUT",
  "Quelle": "Quelle",
  "Reaktivieren": "Reaktivieren",
  "Rechte": "Rechte",
  "Rechte bearbeiten": "Rechte bearbeiten",
  "Rechte für Neuanlage übernommen.": "Rechte für Neuanlage übernommen.",
  "Rechte gespeichert.": "Rechte gespeichert.",
  "Rechtliche Links": "Rechtliche Links",
  "Reseller": "Reseller",
  "Reseller Admin": "Reseller Admin",
  "Reseller aktivieren oder deaktivieren": "Reseller aktivieren oder deaktivieren",
  "Reseller anlegen": "Reseller anlegen",
  "Reseller editieren": "Reseller editieren",
  "Reseller impersonieren": "Vollzugriff auf Reseller",
  "Reseller Name": "Reseller Name",
  "Reseller Name (optional)": "Reseller Name (optional)",
  "reseller@partner.tld": "reseller@partner.tld",
  "Sa": "Sa",
  "So": "So",
  "Speichern": "Speichern",
  "Speichert…": "Speichert…",
  "Sperren": "Sperren",
  "startExport failed": "startExport failed",
  "startExport failed:": "startExport failed:",
  "Status": "Status",
  "Betriebsstättenweit": "Betriebsstättenweit",
  "Stop": "Stop",
  "Suche (Datei, Typ, Unternehmen, Betriebsstätte, POS)": "Suche (Datei, Typ, Unternehmen, Betriebsstätte, POS)",
  "Suche (Name, E-Mail)": "Suche (Name, E-Mail)",
  "Suche (Name, E-Mail, Status)": "Suche (Name, E-Mail, Status)",
  "Suche (Organisation, Ansprechpartner, E-Mail, Reseller)": "Suche (Organisation, Ansprechpartner, E-Mail, Reseller)",
  "Suche (POS, Unternehmen, Betriebsstätte, Status)": "Suche (POS, Unternehmen, Betriebsstätte, Status)",
  "Suche (Reseller, Organisation, Ansprechpartner, E-Mail, Status)": "Suche (Reseller, Organisation, Ansprechpartner, E-Mail, Status)",
  "Suche (Unternehmen, Betriebsstätte, POS)": "Suche (Unternehmen, Betriebsstätte, POS)",
  "Suche (Zeit, Event, Akteur)": "Suche (Zeit, Event, Akteur)",
  "Suche zurücksetzen": "Suche zurücksetzen",
  "E-Mail zurücksetzen": "E-Mail zurücksetzen",
  "Filter zurücksetzen": "Filter zurücksetzen",
  "Swissbit Cloud TSE": "Swissbit Cloud TSE",
  "Swissbit HW TSE": "Swissbit HW TSE",
  "Tenant Admin": "Hauptnutzer",
  "Tenant User": "Standardnutzer",
  "TSE Seriennummer": "TSE Seriennummer",
  "TSE Seriennummer (optional)": "TSE Seriennummer (optional)",
  "TSE Seriennummer fehlt.": "TSE Seriennummer fehlt.",
  "TSE Seriennummer ist erforderlich.": "TSE Seriennummer ist erforderlich.",
  "TSE Typ": "TSE Typ",
  "TSE-TAR": "TSE-TAR",
  "TT.MM.JJJJ": "TT.MM.JJJJ",
  "TT.MM.JJJJ - TT.MM.JJJJ": "TT.MM.JJJJ - TT.MM.JJJJ",
  "Typ": "Typ",
  "Uhrzeit": "Uhrzeit",
  "Umbenennen": "Umbenennen",
  "Unternehmen": "Unternehmen",
  "Unternehmen anlegen": "Unternehmen anlegen",
  "Unternehmen neu anlegen": "Unternehmen neu anlegen",
  "Unternehmen verwalten": "Unternehmen verwalten",
  "Unternehmen wählen": "Unternehmen wählen",
  "Unternehmensname": "Unternehmensname",
  "Unternehmensstruktur": "Unternehmensstruktur",
  "Unternehmen löschen": "Unternehmen löschen",
  "Unternehmensweit": "Unternehmensweit",
  "Updated": "Updated",
  "Upload deaktiviert: Unternehmen mit gültigem Länderprofil auswählen.": "Upload deaktiviert: Unternehmen mit gültigem Länderprofil auswählen.",
  "Datei zu groß. Maximal 2 GB pro Datei.": "Datei zu groß. Maximal 2 GB pro Datei.",
  "Dateien zur Archivierung": "Dateien zur Archivierung",
  "Upload fehlgeschlagen.": "Upload fehlgeschlagen.",
  "Upload-Details": "Upload-Details",
  "Upload verwerfen": "Upload verwerfen",
  "Upload verwerfen und ausloggen": "Upload verwerfen und ausloggen",
  "Upload verwerfen und Impersonation beenden": "Upload verwerfen und Vollzugriff beenden",
  "Upload verwerfen?": "Upload verwerfen?",
  "User": "User",
  "Verbindlich archivieren": "Verbindlich archivieren",
  "Verfahrensdoku": "Verfahrensdoku",
  "Verwalten Sie hier alle Ihre Daten rund um die Kasse im Swissbit": "Verwalten Sie hier alle Ihre Daten rund um die Kasse im Swissbit",
  "Von": "Von",
  "Vorname Nachname": "Vorname Nachname",
  "Warte auf Passkey…": "Warte auf Passkey…",
  "Sende Reset-Link…": "Sende Reset-Link…",
  "Sitzung wird geladen…": "Sitzung wird geladen…",
  "Speichern…": "Speichern…",
  "Zurück zum Login": "Zurück zum Login",
  "Reset-Link fehlt oder ist ungültig.": "Reset-Link fehlt oder ist ungültig.",
  "Wenn die E-Mail-Adresse bekannt ist, wurde ein Reset-Link versendet.": "Wenn die E-Mail-Adresse bekannt ist, wurde ein Reset-Link versendet.",
  "Web-Upload": "Web-Upload",
  "Widerrufen": "Widerrufen",
  "X-Tenant-Id": "X-Tenant-Id",
  "X-User-Role": "X-User-Role",
  "z. B. TSE Zertifikat": "z. B. TSE Zertifikat",
  "Zeit": "Zeit",
  "Zeitraum": "Zeitraum",
  "Zeitraum ungültig: \"Bis\" liegt vor \"Von\".": "Zeitraum ungültig: \"Bis\" liegt vor \"Von\".",
  "Zuklappen": "Zuklappen",
  "Zuletzt verwendet": "Zuletzt verwendet",
  "Zurücksetzen": "Zurücksetzen",
  "POS löschen": "POS löschen",
  "Zurückweisen": "Zurückweisen",
  "Zusammenfassung": "Zusammenfassung",
  "Zuweisen": "Zuweisen",
  "Zuweisung": "Zuweisung",
  "Alle offenen Anfragen auswählen": "Alle offenen Anfragen auswählen",
  "Ausgewählte freigeben": "Ausgewählte freigeben",
  "Freigabe läuft ...": "Freigabe läuft ...",
  "aktivieren": "aktivieren",
  "deaktivieren": "deaktivieren",
  "entsperren": "entsperren",
  "sperren": "sperren",
  "Clipboard nicht verfügbar.": "Clipboard nicht verfügbar.",
  "E-Mail ist erforderlich.": "E-Mail ist erforderlich.",
  "Einstellungen": "Einstellungen",
  "Einstellungen ausblenden": "Einstellungen ausblenden",
  "Einstellungen speichern": "Einstellungen speichern",
  "Einstellungen gespeichert.": "Einstellungen gespeichert.",
  "Einstellungen konnten nicht gespeichert werden.": "Einstellungen konnten nicht gespeichert werden.",
  "Passwort zurücksetzen": "Passwort zurücksetzen",
  "POS-Seriennummer": "POS-Seriennummer",
  "Sprache": "Sprache",
  "Bitte Betriebsstätte wählen oder neu anlegen.": "Bitte Betriebsstätte wählen oder neu anlegen.",
  "Bitte Unternehmen wählen oder neu anlegen.": "Bitte Unternehmen wählen oder neu anlegen.",
  "Bitte ein bestehendes Unternehmen wählen. Die Neuanlage erfordert das Recht Unternehmen verwalten.": "Bitte ein bestehendes Unternehmen wählen. Die Neuanlage erfordert das Recht Unternehmen verwalten.",
  "Bitte eine bestehende Betriebsstätte wählen. Die Neuanlage erfordert das Recht Betriebsstätten verwalten.": "Bitte eine bestehende Betriebsstätte wählen. Die Neuanlage erfordert das Recht Betriebsstätten verwalten.",
  "Prüfe Link…": "Prüfe Link…",
  "Reset-Link ist ungültig oder abgelaufen.": "Reset-Link ist ungültig oder abgelaufen.",
  "Reset-Link konnte nicht geprüft werden.": "Reset-Link konnte nicht geprüft werden.",
  "SHA-256 wird von diesem Browser nicht unterstützt.": "SHA-256 wird von diesem Browser nicht unterstützt.",
  "Upload konnte nicht verworfen werden.": "Upload konnte nicht verworfen werden.",
  "Upload läuft. Der Dialog ist gesperrt, bis die Datei vollständig übertragen wurde.": "Upload läuft. Der Dialog ist gesperrt, bis die Datei vollständig übertragen wurde.",
  "Upload läuft…": "Upload läuft…",
  "Der aktuelle Upload-Vorgang wird zuerst abgeschlossen. Danach werden verbleibende Dateien und Upload-Auswahlen verworfen. Dies kann nicht rückgängig gemacht werden.": "Der aktuelle Upload-Vorgang wird zuerst abgeschlossen. Danach werden verbleibende Dateien und Upload-Auswahlen verworfen. Dies kann nicht rückgängig gemacht werden.",
  "Der aktuelle Upload-Vorgang wird abgeschlossen. Die gewählte Aktion wird danach automatisch fortgesetzt.": "Der aktuelle Upload-Vorgang wird abgeschlossen. Die gewählte Aktion wird danach automatisch fortgesetzt.",
  "Bitte beachten Sie, dass der Name einer Betriebsstätte nach dem Anlegen derzeit nicht geändert werden kann.": "Bitte beachten Sie, dass der Name einer Betriebsstätte nach dem Anlegen derzeit nicht geändert werden kann.",
  "Bitte beachten Sie, dass der Name eines Unternehmens nach dem Anlegen derzeit nicht geändert werden kann.": "Bitte beachten Sie, dass der Name eines Unternehmens nach dem Anlegen derzeit nicht geändert werden kann.",
  "Upload wird abgeschlossen…": "Upload wird abgeschlossen…"
}

export const DE_UI_TEMPLATES = {
  "archive.total": "Archivierte Artefakte (Summe {{size}})",
  "aria.export.download": "Export {{id}} herunterladen",
  "confirm.delete.company": "Unternehmen \"{{label}}\" inkl. aller Betriebsstätten und POS wirklich löschen?",
  "confirm.delete.api_key": "API-Key für POS \"{{label}}\" wirklich löschen?",
  "confirm.delete.generic": "{{label}} wirklich löschen?",
  "confirm.delete.passkey": "Passkey \"{{label}}\" wirklich löschen?",
  "confirm.delete.pos": "POS \"{{label}}\" wirklich löschen?",
  "confirm.delete.site": "Betriebsstätte \"{{label}}\" inkl. aller POS wirklich löschen?",
  "confirm.delete.upload_file": "\"{{label}}\" wirklich löschen? Löschen kann nicht rückgängig gemacht werden.",
  "confirm.delete.user": "Nutzer \"{{label}}\" wirklich löschen?",
  "confirm.onboarding_code.generate_another": "Der aktuell angezeigte Onboarding-Code wird danach nicht mehr angezeigt, bleibt aber weiterhin gültig. Stellen Sie sicher, dass Sie ihn zuvor kopiert oder im POS-Managementsystem hinterlegt haben. Möchten Sie einen weiteren Onboarding-Code erzeugen?",
  "confirm.reject.api_key": "API-Key-Anfrage für POS \"{{label}}\" wirklich zurückweisen?",
  "confirm.toggle.generic": "{{label}} wirklich {{action}}?",
  "confirm.toggle.user": "Nutzer \"{{label}}\" wirklich {{action}}?",
  "confirm.withdraw.impersonation_access": "Vollzugriffs-Freigabe für \"{{label}}\" wirklich zurückziehen? Aktive Vollzugriffs-Sessions werden beendet.",
  "confirm.revoke.impersonation_access": "Vollzugriff für \"{{label}}\" wirklich widerrufen? Aktive Vollzugriffs-Sessions werden beendet.",
  "entity.deleted": "{{name}} (gelöscht)",
  "entity.deleted_at": "{{name}} (gelöscht am {{date}})",
  "export.category.count": "{{label}} ({{count}})",
  "export.requested": "Export angefordert. Den Status sehen Sie unter „Letzte Exporte“; sobald er bereitsteht, können Sie ihn dort herunterladen.",
  "export.preview.load_failed": "Vorschau konnte nicht geladen werden.",
  "export.preview.selected_of_total": "Ausgewählte Treffer: {{selected}} von {{total}}",
  "selection.count": "{{selected}} von {{total}} ausgewählt",
  "export.tooltip.artifact_group": "Artefaktgruppe: {{value}}",
  "export.tooltip.company": "Unternehmen: {{value}}",
  "export.tooltip.id": "Export-ID: {{value}}",
  "export.tooltip.period": "Zeitraum: {{value}}",
  "export.tooltip.pos": "POS: {{value}}",
  "export.tooltip.site": "Betriebsstätte: {{value}}",
  "ingest.tooltip.group_id": "Gruppen-ID: {{value}}",
  "impersonation.request.pending_count_from_prefix": "Sie haben {{count}} offene Impersonationsanfragen von ",
  "impersonation.request.pending_from_prefix": "Sie haben eine offene Impersonationsanfrage von ",
  "range.from_to": "{{from}} - {{to}}",
  "status.value": "Status: {{value}}",
  "upload.committed": "Upload angenommen. Die Dateien werden im Hintergrund geprüft und archiviert.",
  "upload.pos_selected_count": "{{count}} ausgewählt",
  "aria.company.collapse": "Unternehmen {{name}} einklappen",
  "aria.company.expand": "Unternehmen {{name}} ausklappen",
  "aria.site.collapse": "Betriebsstätte {{name}} einklappen",
  "aria.site.expand": "Betriebsstätte {{name}} ausklappen",
  "api_keys.bulk.result": "{{approved}} API-Keys freigegeben.",
  "api_keys.bulk.result_failed": "{{approved}} freigegeben, {{failed}} konnten nicht freigegeben werden.",
  "pos.api_key.aria": "API-Key für {{pos}}",
  "pos.api_key.setup.belongs_to.prefix": "Dieser API-Key gehört ausschließlich zur POS mit der Seriennummer ",
  "pos.api_key.setup.belongs_to.suffix": ". Hinterlegen Sie ihn direkt in der POS oder in den entsprechenden Einstellungen Ihres POS-Verwaltungssystems.",
  "upload.transfer.locked.progress": "Upload läuft ({{percent}} %). Der Dialog ist gesperrt, bis die Datei vollständig übertragen wurde.",
  "upload.transfer.progress": "Upload läuft ({{percent}} %)…"
}
